import { render, staticRenderFns } from "./SingleReport.vue?vue&type=template&id=2ed1f514&scoped=true&"
import script from "./SingleReport.vue?vue&type=script&lang=js&"
export * from "./SingleReport.vue?vue&type=script&lang=js&"
import style0 from "./SingleReport.vue?vue&type=style&index=0&id=2ed1f514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1f514",
  null
  
)

export default component.exports